var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fx-no-trans-details" }, [
    _c("div", { staticClass: "container-content" }, [
      _c("div", { staticClass: "no-support-content" }, [
        _c("img", {
          attrs: { src: require("@/assets/svg/tip_no_support.svg") },
        }),
        _c(
          "div",
          {
            staticClass: "tip-text",
            staticStyle: { "font-size": "32px", "font-weight": "600" },
          },
          [
            _vm._v(
              " " + _vm._s(_vm.$t("tips.feature_not_supported_country")) + " "
            ),
          ]
        ),
        _c("div", { staticClass: "tip-text" }, [
          _vm._v(" " + _vm._s(_vm.$t("tips.try_another_country")) + " "),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }